<div role="document" [attr.class]="'modal-dialog' + (size ? ' modal-' + size : '') + (centered ? ' modal-dialog-centered' : '')">
    <div class="modal-content">
        @if (showDialogHeader) {
            <div class="modal-dialog-header-wrapper" id="headerWrapper">
                <div class="header" [class.default-header]="!headerTemplate">
                    @if (showBackNav) {
                        <div class="header-back" tabindex="0" (click)="goBack()" (keydown.escape)="goBack()" (keydown.backspace)="goBack()">
                            <i class="theme-left"></i>
                        </div>
                    }
                    @if (headerTemplate) {
                        <ng-container *ngTemplateOutlet="headerTemplate" />
                    } @else if (!hideCloseButton) {
                        @if (showCloseBtnText) {
                            <button class="betstation-btn-close" (click)="close()">
                                <span class="text">{{ closeText }}</span>
                                <i class="close-icon theme-ex" [msAutomation]="'header-close-icon'"></i>
                            </button>
                        } @else {
                            @if (showCloseIcon) {
                                <i class="close theme-ex" tabindex="0" [msAutomation]="'header-close-icon'" (click)="close()" (keydown)="close()"></i>
                            } @else {
                                <button class="close" [msAutomation]="'header-close-icon'" (click)="close()">
                                    {{ closeText }}
                                </button>
                            }
                        }
                    }

                    @if (title) {
                        <div class="header-title">{{ title }}</div>
                    }
                </div>
            </div>
        }
        <div class="modal-body">
            <ng-content />
        </div>
    </div>
</div>
